import useFooter from '../../application/hooks/useFooter';
import {
  VisualBox,
  DefaultBox,
  FloatingFlexBox,
  SideBox,
  CtaBoxWrap,
} from '../etc/LBox/LBox';
import styled from 'styled-components';

import {
  Button,
  Skeleton,
  CheckboxBottomsheet,
  Popup,
  Description,
  TheFooter,
  Spacer,
} from 'oui';
import Observer from '../etc/Observer/Observer';
import TermFullSheet from '../feedback/TermFullSheet/TermFullSheet';
import React from 'react';
import usePromotion from '../../application/bloc/usePromotion';
import StackingSnackbar from '../component/StackingSnackbar/StackingSnackbar';

const MainButton = ({
  isInactive,
  inactiveButtonName,
  activeButtonName,
  onClick,
}: {
  isInactive: boolean;
  inactiveButtonName: string;
  activeButtonName: string;
  onClick: () => void;
}) => {
  return (
    <Button
      flexible={true}
      configuration={'contained'}
      state={isInactive ? 'disabled' : 'enabled'}
      isDisabled={isInactive}
      onClick={onClick}
      children={isInactive ? inactiveButtonName : activeButtonName}
    />
  );
};

const CompareButton = ({ onClick }: { onClick: (e: any) => void }) => {
  return (
    <Button
      flexible={false}
      configuration={'contained'}
      state={'enabled'}
      isDisabled={false}
      onClick={onClick}
      maxWidth={110}
      minWidth={110}
      children={'비교하기'}
    />
  );
};

const Promotion = () => {
  const {
    isLoading,

    promo,
    onClickCompareButton,
    actByPromotionLink,
    isInactiveButton,
    popup,
    floating,

    termAgreeButtonName,
    termBottomsheet,
    termFullsheet,
    openTermFullsheet,

    submitEvent,
  } = usePromotion();

  const { navigateOvertake, navigateOvertakePrivacy } = useFooter();

  const checkList = termBottomsheet.checkList.map((item) => ({
    isExpand: item.isExpand,
    checked: item.checked,
    text: item.text,
    icon: true,
    subTextItem: item.subTextItem,
  }));

  return (
    <>
      <StackingSnackbar bottom={120} />
      {isLoading ? (
        <>
          {promo?.sectionList?.map((section: any, idx: number) => {
            if (section.sectionType === 'image') {
              return (
                <VisualBox key={idx}>
                  <img
                    src={section.imageFileUrl}
                    alt={'promo-1'}
                    style={{ verticalAlign: 'top' }}
                  />
                </VisualBox>
              );
            } else if (section.sectionType === 'detail') {
              return (
                <Description
                  key={idx}
                  infoText={''}
                  productOptions={section.detailList.map(
                    (detail: { title: any; content: any }, index: number) => ({
                      title: detail.title,
                      description: detail.content,
                      key: +index,
                    }),
                  )}
                />
              );
            } else if (section.sectionType === 'button') {
              return (
                <div key={idx}>
                  <div
                    style={{
                      display: `${
                        section.activeButtonName2 ? 'flex' : 'block'
                      }`,
                      justifyContent: `${
                        section.activeButtonName2 ? 'space-between' : 'center'
                      }`,
                      gap: '8px',
                      padding: '0 20px',
                    }}
                  >
                    {
                      <CtaBoxWrap twoButton={section.activeButtonName2}>
                        <Observer
                          handleState={(e: any) => floating.setFloating(e)}
                        >
                          <MainButton
                            isInactive={isInactiveButton(
                              section.inactiveButtonYn1,
                              section.inactiveButtonRequirement1,
                            )}
                            onClick={() => {
                              actByPromotionLink(
                                section.linkType1,
                                section.redirectionUrl1,
                                section.activeButtonName1,
                              );
                            }}
                            inactiveButtonName={section.inactiveButtonName1}
                            activeButtonName={section.activeButtonName1}
                          />
                        </Observer>
                      </CtaBoxWrap>
                    }

                    {section.activeButtonName2 && (
                      <CtaBoxWrap twoButton={true}>
                        <MainButton
                          isInactive={isInactiveButton(
                            section.inactiveButtonYn2,
                            section.inactiveButtonRequirement2,
                          )}
                          onClick={() => {
                            actByPromotionLink(
                              section.linkType2,
                              section.redirectionUrl2,
                              section.activeButtonName2,
                            );
                          }}
                          inactiveButtonName={section.inactiveButtonName2}
                          activeButtonName={section.activeButtonName2}
                        />
                      </CtaBoxWrap>
                    )}
                  </div>
                  {(section.floatingButtonYn1 === 'Y' ||
                    section.floatingButtonYn2 === 'Y') && (
                    <FloatingFlexBox status={floating.isFloating}>
                      {/* {(section.floatingButtonYn1 !== 'Y' || section.floatingButtonYn2 !== 'Y') &&
                        <CompareButton onClick={onClickCompareButton}/>
                      } */}
                      {section.floatingButtonYn1 === 'Y' && (
                        <MainButton
                          isInactive={isInactiveButton(
                            section.inactiveButtonYn1,
                            section.inactiveButtonRequirement1,
                          )}
                          onClick={() => {
                            actByPromotionLink(
                              section.linkType1,
                              section.redirectionUrl1,
                              section.activeButtonName1,
                            );
                          }}
                          inactiveButtonName={section.inactiveButtonName1}
                          activeButtonName={section.activeButtonName1}
                        />
                      )}

                      {section.floatingButtonYn2 === 'Y' && (
                        <>
                          <div style={{ width: '16px' }}></div>
                          <MainButton
                            isInactive={isInactiveButton(
                              section.inactiveButtonYn2,
                              section.inactiveButtonRequirement2,
                            )}
                            onClick={() => {
                              actByPromotionLink(
                                section.linkType2,
                                section.redirectionUrl2,
                                section.activeButtonName2,
                              );
                            }}
                            inactiveButtonName={section.inactiveButtonName2}
                            activeButtonName={section.activeButtonName2}
                          />
                        </>
                      )}
                    </FloatingFlexBox>
                  )}
                </div>
              );
            }
          })}

          <TheFooter
            type={'e'}
            titleTypeE={promo.bottomGuideTitle}
            html={promo.bottomGuideContent}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
          />
          <Spacer size="lg" />
        </>
      ) : (
        <Skeleton type={'a'} />
      )}

      <CheckboxBottomsheet
        isOpenCheckBottomsheet={termBottomsheet.isOpen}
        title={'약관에 동의하시면\n 대출 조회를 도와드릴게요'}
        buttonText={termAgreeButtonName || '동의하고 대출 심사 진행하기'}
        buttonState={termBottomsheet.isActive ? 'enabled' : 'disabled'}
        buttonIsDisabled={!termBottomsheet.isActive}
        checkboxItems={checkList}
        onClickCheck={(idx: number) => termBottomsheet.toggleCheckBox(idx)}
        onClickExpand={openTermFullsheet}
        onClickElementLabel={openTermFullsheet}
        onClickSubmitButton={submitEvent}
        onCloseCheckBottomsheet={termBottomsheet.close}
        toast={''}
      />

      <TermFullSheet
        isOpen={termFullsheet.isOpen}
        title={termFullsheet.title}
        path={termFullsheet.path}
        onClickClose={termFullsheet.close}
      />
      <Popup isPopupOpen={popup.open} title={popup.message} />
    </>
  );
};

export default Promotion;
